/**
 * Classify what the kernel watchdog should do after a sustained disconnection.
 *
 * Returns 'ignore' when the disconnection is expected (workspace tearing down),
 * 'error' exactly once at the reconnect threshold, or 'breadcrumb' for all
 * other watchdog cycles to avoid flooding Sentry.
 */

import { WorkspaceState } from '@/lib/types/rome';

const RECONNECT_LOOP_THRESHOLD = 3;

const TEARDOWN_STATES = new Set<WorkspaceState>([
  WorkspaceState.STOPPING,
  WorkspaceState.STOPPED,
  WorkspaceState.TERMINATING,
  WorkspaceState.TERMINATED,
]);

export function classifyWatchdogAction(
  reconnectCount: number,
  workspaceState: WorkspaceState | undefined
): 'ignore' | 'error' | 'breadcrumb' {
  if (workspaceState && TEARDOWN_STATES.has(workspaceState)) {
    return 'ignore';
  }

  if (reconnectCount === RECONNECT_LOOP_THRESHOLD) {
    return 'error';
  }

  return 'breadcrumb';
}
